module.exports = __webpack_public_path__ + "static/media/fr.449e1114.svg";